import { render, staticRenderFns } from "./DownloadPopup.vue?vue&type=template&id=1e8a10a2&"
import script from "./DownloadPopup.vue?vue&type=script&lang=js&"
export * from "./DownloadPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports